<section class="checkout-payment">
  <p class="checkout-payment__eyebrow" i18n="@@checkout.payment.eyebrow">付款方式 Payment</p>

  <div class="checkout-payment__toggle">
    <button type="button"
            class="checkout-payment__toggle-half"
            [class.is-active]="paymentMode === 'ONLINE'"
            (click)="setMode('ONLINE')">
      <span class="checkout-payment__radio">{{ paymentMode === 'ONLINE' ? '◉' : '○' }}</span> <ng-container i18n="@@checkout.payment.mode.online">網上付款</ng-container>
    </button>
    <button type="button"
            class="checkout-payment__toggle-half"
            [class.is-active]="paymentMode === 'MANUAL'"
            (click)="setMode('MANUAL')">
      <span class="checkout-payment__radio">{{ paymentMode === 'MANUAL' ? '◉' : '○' }}</span> <ng-container i18n="@@checkout.payment.mode.manual">手動轉賬</ng-container>
    </button>
  </div>

  <ng-container *ngIf="paymentMode === 'ONLINE'">
    <div class="checkout-payment__methods">
      <button type="button"
              *ngFor="let m of methods; let i = index"
              class="checkout-payment__method"
              [class.is-active]="isSelected(m)"
              [class.checkout-payment__method--wide]="i === methods.length - 1 && methods.length % 2 === 1"
              (click)="selectMethod(m)">
        <img [src]="m.icon" [alt]="m.label" class="checkout-payment__method-icon"
             onerror="this.style.display='none'">
        <span class="checkout-payment__method-label">{{ m.label }}</span>
      </button>
    </div>
    <p class="checkout-payment__hint" *ngIf="!selectedMethod" i18n="@@checkout.payment.hint">請選擇付款方式</p>
  </ng-container>

  <div class="checkout-payment__divider"></div>

  <p class="checkout-payment__terms" i18n="@@checkout.payment.terms">
    本人點擊「確認訂單」<br>即代表本人已同意本人的購買將受<br>
    <a href="#/posts/terms-and-conditions">訂購須知、條款及細則</a>及<a href="#/posts/privacy-policy">私隱政策</a>的約束。
  </p>

  <button type="button" class="checkout-payment__submit" (click)="onSubmit()" i18n="@@checkout.payment.submit">確認訂單</button>
</section>
